/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */
import axiosStatic from 'axios';
import type { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
  /**
   * show loading status
   */
  loading?: boolean;
  /**
   * display error message
   */
  showError?: boolean;
  /**
   * indicates whether Authorization credentials are required for the request
   * @default true
   */
  withAuthorization?: boolean;
}

export interface IRequestPromise<T = any> extends Promise<IRequestResponse<T>> {}

export interface IRequestResponse<T = any> {
  data: T;
  status: number;
  statusText: string;
  headers: any;
  config: any;
  request?: any;
}

export interface IRequestInstance {
  (config: any): IRequestPromise;
  (url: string, config?: any): IRequestPromise;
  request<T = any>(config: any): IRequestPromise<T>;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: IRequestInstance;
  /** only in axios interceptor config*/
  loading: boolean;
  showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = {
    loading: serviceOptions.loading,
    showError: serviceOptions.showError,
    ...options,
    method,
    url
  };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class AiService {
  /**
   * Generates view changes from a natural language request
   */
  static viewChanges(
    params: {
      /** requestBody */
      body?: AiViewChangeRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AiViewChangesResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/ai/view-changes';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class AirportService {
  /**
   *
   */
  static getAirportData(
    params: {
    
      airportId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AirportDataResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/airport/{airportId}/data';
      url = url.replace('{airportId}', params['airportId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class AuthService {
  /**
   *
   */
  static loginAsync(
    params: {
      /** requestBody */
      body?: LoginRequestModelV2;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<LoginResponseModelV2> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/auth/login';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static refreshTokenAsync(
    params: {
      /** requestBody */
      body?: RefreshTokenRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<RefreshTokenResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/auth/refresh-token';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static logoutAsync(
    params: {
      /** requestBody */
      body?: LogoutRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/auth/logout';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Finish SSO auth process
   */
  static loginSsoComplete(options: IRequestOptions = {}): Promise<LoginSsoResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/auth/community-portal/complete';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Login to Aviation Sentry
   */
  static aviationSentryLoginAsync(options: IRequestOptions = {}): Promise<AviationSentryLoginResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/auth/aviation-sentry';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class DiversionManagerService {
  /**
   *
   */
  static getInfoAsync(options: IRequestOptions = {}): Promise<GetAirportDiversionCapacityResponse[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/diversion-manager/info';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class DrawingObjectsService {
  /**
   * Retrieves all drawing objects based on optional filters
   */
  static getAllAsync(
    params: {
    
      lastUpdate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DrawingObjectsGetResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/drawing-objects';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { LastUpdate: params['lastUpdate'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create a new drawing object
   */
  static createAsync(
    params: {
      /** requestBody */
      body?: DrawingObjectCreateOrUpdateRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DrawingObjectCreateResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/drawing-objects';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get drawing object by ID
   */
  static getByIdAsync(
    params: {
    
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<DrawingObjectGetResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/drawing-objects/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update drawing object by id
   */
  static updateAsync(
    params: {
    
      id: string;
      /** requestBody */
      body?: DrawingObjectCreateOrUpdateRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/drawing-objects/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete a Drawing
   */
  static deleteAsync(
    params: {
    
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/drawing-objects/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class FilterGroupsService {
  /**
   * Retrieves all filter groups based on optional filters
   */
  static getFilterGroups(
    params: {
    
      lastUpdate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetFilterGroupsResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/filter-groups';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { LastUpdate: params['lastUpdate'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create a filter group
   */
  static createFilterGroup(
    params: {
      /** requestBody */
      body?: CreateFilterGroupRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FilterGroupDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/filter-groups';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get filter group by ID
   */
  static getFilterGroupById(
    params: {
    
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FilterGroupDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/filter-groups/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update a filter group
   */
  static updateFilterGroup(
    params: {
    
      id: string;
      /** requestBody */
      body?: UpdateFilterGroupRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FilterGroupDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/filter-groups/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete a filter group
   */
  static deleteFilterGroup(
    params: {
    
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/filter-groups/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class FlightDataService {
  /**
   * Get winds for flight route
   */
  static getFlightRouteWindsAsync(
    params: {
      /** requestBody */
      body?: GetFlightRouteWindsRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FEServerFlightDataRouteWinds[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/flight-data/winds';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class FlightDataEntryService {
  /**
   * Request ACARS position
   */
  static requestAcarsPosition(
    params: {
      /** requestBody */
      body?: AcarsPositionRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/flight-data-entry/acars-position';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Set ACARS position update frequency
   */
  static setAcarsPositionUpdateFrequency(
    params: {
      /** requestBody */
      body?: AcarsPositionUpdateFrequencyRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/flight-data-entry/acars-position/frequency';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Set diversion recovery priority
   */
  static setDiversionRecoveryPriority(
    params: {
      /** requestBody */
      body?: DiversionRecoveryPriorityRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/flight-data-entry/diversion-recovery-priority';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Submit manual 3DPI time entry
   */
  static submitManualThreeDpiEntry(
    params: {
      /** requestBody */
      body?: ManualThreePdiEntryRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/flight-data-entry/manual-entry';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Set departure gate
   */
  static setDepartureGate(
    params: {
      /** requestBody */
      body?: DepartureGateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/flight-data-entry/departure-gate';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Set arrival gate
   */
  static setArrivalGate(
    params: {
      /** requestBody */
      body?: ArrivalGateRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/flight-data-entry/arrival-gate';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class FpmDataService {
  /**
   *
   */
  static uploadAsync(
    params: {
    
      file: any;
    
      date: string;
    
      version: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/fpm-data/upload';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = undefined;
      data = new FormData();
      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any);
          }
        } else {
          data.append('file', params['file'] as any);
        }
      }

      if (params['date']) {
        if (Object.prototype.toString.call(params['date']) === '[object Array]') {
          for (const item of params['date']) {
            data.append('Date', item as any);
          }
        } else {
          data.append('Date', params['date'] as any);
        }
      }

      if (params['version']) {
        if (Object.prototype.toString.call(params['version']) === '[object Array]') {
          for (const item of params['version']) {
            data.append('Version', item as any);
          }
        } else {
          data.append('Version', params['version'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class MonitorSettingsService {
  /**
   * Retrieves user and company Mon settings
   */
  static getAllAsync(
    params: {
    
      lastUpdate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FEMonitorSettingsModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/monitor-settings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { LastUpdate: params['lastUpdate'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update company and user Mon settings
   */
  static modifyAsync(
    params: {
      /** requestBody */
      body?: FEMonitorSettingsModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/monitor-settings';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class NotamService {
  /**
   *
   */
  static searchAsync(
    params: {
    
      query: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NotamSearchResultItem[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/notam/search';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Query: params['query'] };

      axios(configs, resolve, reject);
    });
  }
}

export class NotesService {
  /**
   * Retrieves all notes based on optional filters
   */
  static getNotes(
    params: {
    
      lastUpdate?: string;
    
      itemIds?: any | null[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetNotesResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/notes';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { LastUpdate: params['lastUpdate'], ItemIds: params['itemIds'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create note
   */
  static createNote(
    params: {
      /** requestBody */
      body?: CreateNoteRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NoteDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/notes';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get note by ID
   */
  static getNoteById(
    params: {
    
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NoteDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/notes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update note
   */
  static updateNote(
    params: {
    
      id: string;
      /** requestBody */
      body?: UpdateNoteRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<NoteDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/notes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete note
   */
  static deleteNote(
    params: {
    
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/notes/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get notes summary
   */
  static getNotesSummary(options: IRequestOptions = {}): Promise<NoteItemsSummaryDto> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/notes/summary';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class PhaseOfTaxiOperationsService {
  /**
   * Retrieves all taxi operations for a given airport
   */
  static getTaxiOperations(
    params: {
    
      aerodrome: string;
    
      hours?: number;
    
      airline?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetHistoricalDurationsResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/phase-of-taxi-operations/taxi-operations';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { Aerodrome: params['aerodrome'], Hours: params['hours'], Airline: params['airline'] };

      axios(configs, resolve, reject);
    });
  }
}

export class SettingsService {
  /**
   * Retrieves user settings
   */
  static getUserSettingsAsync(options: IRequestOptions = {}): Promise<GetUserSettingsResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/settings';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update user setting
   */
  static updateUserSettingAsync(
    params: {
      /** requestBody */
      body?: UpdateUserSettingRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/settings';

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets map settings
   */
  static getMapSettingsAsync(options: IRequestOptions = {}): Promise<GetMapSettingsResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/settings/map';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Gets custom events for user
   */
  static getCustomEventsAsync(options: IRequestOptions = {}): Promise<GetCustomEventsResponseModelItem[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/settings/custom-events';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class SystemHubService {
  /**
   * Get system hub status report
   */
  static getStatusAsync(
    params: {
    
      lastUpdate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SystemHubStatusModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/system-hub/status';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { lastUpdate: params['lastUpdate'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get system hub data
   */
  static getDataAsync(options: IRequestOptions = {}): Promise<SystemHubDetails> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/system-hub/data';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

export class UserService {
  /**
   * Creates a new user feedback item
   */
  static createFeedbackAsync(
    params: {
      /** requestBody */
      body?: FeedbackRequestModelV2;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/user/feedback';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export class ViewsService {
  /**
   * Retrieves all UD View based on optional filters
   */
  static getAllAsync(
    params: {
    
      lastUpdate?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<GetUDViewResponseModelV2> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/views';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { LastUpdate: params['lastUpdate'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   * Create a UD View
   */
  static createAsync(
    params: {
      /** requestBody */
      body?: UdViewCreateOrUpdateRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UdViewCreateResponseModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/views';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Get UD View by ID
   */
  static getByIdAsync(
    params: {
    
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<UDViewModel> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/views/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   * Update a UD View
   */
  static updateAsync(
    params: {
    
      id: string;
      /** requestBody */
      body?: UdViewCreateOrUpdateRequestModel;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/views/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete a UD View
   */
  static deleteAsync(
    params: {
    
      id: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/v2/views/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
}

/** AcarsPositionRequest */
export interface AcarsPositionRequest {  aircraftId?: string;
  origin?: string;
  originalDepartureDateTime?: string;
}

/** AcarsPositionUpdateFrequencyRequest */
export interface AcarsPositionUpdateFrequencyRequest {  aircraftId?: string;
  origin?: string;
  originalDepartureDateTime?: string;
  updateFrequencyMinutes?: number;
}

/** AiFilterUpdate */
export interface AiFilterUpdate {  alias?: string;
  filter?: UDViewPlaneFilterSettingModel;
}

/** AiViewChangeRequest */
export interface AiViewChangeRequest {  prompt?: string;
  conversationHistory?: ChatTurn[];
  viewSnapshot?: AiViewSnapshot;
}

/** AiViewChangesResponse */
export interface AiViewChangesResponse {  kind?: AiResponseKind;
  message?: string;
  addFilters?: UDViewPlaneFilterSettingModel[];
  updateFilters?: AiFilterUpdate[];
  removeFilterAliases?: string[];
  clarification?: Clarification;
}

/** AiViewSnapshot */
export interface AiViewSnapshot {  name?: string;
  filters?: UDViewPlaneFilterSettingModel[];
}

/** AircraftThresholdAlertOptions */
export interface AircraftThresholdAlertOptions {  eventList?: boolean;
  eventListMinLevel?: ThresholdAlertMinimumLevel;
  eventListAck?: boolean;
  eventListAckMinLevel?: ThresholdAlertMinimumLevel;
  eventListImportant?: boolean;
  eventListImportantMinLevel?: ThresholdAlertMinimumLevel;
  eMail?: boolean;
  eMailMinLevel?: ThresholdAlertMinimumLevel;
  logFile?: boolean;
  logFileMinLevel?: ThresholdAlertMinimumLevel;
  popup?: boolean;
  popupMinLevel?: ThresholdAlertMinimumLevel;
  osAlert?: boolean;
  osAlertMinLevel?: ThresholdAlertMinimumLevel;
  aircraftTag?: boolean;
  aircraftTagMinLevel?: ThresholdAlertMinimumLevel;
  zoomToAircraft?: boolean;
  zoomToAircraftMinLevel?: ThresholdAlertMinimumLevel;
  overrideColor?: boolean;
  overrideColorMinLevel?: ThresholdAlertMinimumLevel;
  enableMarker?: boolean;
  enableMarkerMinLevel?: ThresholdAlertMinimumLevel;
  voice?: boolean;
  voiceMinLevel?: ThresholdAlertMinimumLevel;
  playSound?: boolean;
  playSoundMinLevel?: ThresholdAlertMinimumLevel;
  overrideColorHex?: string;
  alertOnScheduled?: boolean;
  alertOnPlanned?: boolean;
  alertOnActive?: boolean;
}

/** AircraftThresholdItemModel */
export interface AircraftThresholdItemModel {  type?: AircraftThresholdType;
  priority?: number;
  enableState?: ThresholdEnableState;
  info?: AircraftThresholdLevelModel;
  watch?: AircraftThresholdLevelModel;
  warning?: AircraftThresholdLevelModel;
  critical?: AircraftThresholdLevelModel;
  emergency?: AircraftThresholdLevelModel;
  alerts?: AircraftThresholdAlertOptions;
  ignoredTemplateLevels?: ThresholdLevel[];
}

/** AircraftThresholdLevelModel */
export interface AircraftThresholdLevelModel {  repeat?: boolean;
  triggerOnImproving?: boolean;
  value?: number;
  unitIndex?: number;
  actionType?: ThresholdLevelActionType;
  actionTimeMinutes?: number;
}

/** AirportDataResponse */
export interface AirportDataResponse {  magneticVariation?: number;
  runwayPairs?: RunwayPair[];
}

/** AirportMonitorStatusInclude */
export interface AirportMonitorStatusInclude {  originThresholds?: boolean;
  destinationThresholds?: boolean;
  alternateThresholds?: boolean;
}

/** AirportThresholdAlertOptions */
export interface AirportThresholdAlertOptions {  eventList?: boolean;
  eventListMinLevel?: ThresholdAlertMinimumLevel;
  eventListAck?: boolean;
  eventListAckMinLevel?: ThresholdAlertMinimumLevel;
  eventListImportant?: boolean;
  eventListImportantMinLevel?: ThresholdAlertMinimumLevel;
  eMail?: boolean;
  eMailMinLevel?: ThresholdAlertMinimumLevel;
  logFile?: boolean;
  logFileMinLevel?: ThresholdAlertMinimumLevel;
  popup?: boolean;
  popupMinLevel?: ThresholdAlertMinimumLevel;
  osAlert?: boolean;
  osAlertMinLevel?: ThresholdAlertMinimumLevel;
  aircraftTag?: boolean;
  aircraftTagMinLevel?: ThresholdAlertMinimumLevel;
  zoomToAircraft?: boolean;
  zoomToAircraftMinLevel?: ThresholdAlertMinimumLevel;
  overrideColor?: boolean;
  overrideColorMinLevel?: ThresholdAlertMinimumLevel;
  enableMarker?: boolean;
  enableMarkerMinLevel?: ThresholdAlertMinimumLevel;
  voice?: boolean;
  voiceMinLevel?: ThresholdAlertMinimumLevel;
  playSound?: boolean;
  playSoundMinLevel?: ThresholdAlertMinimumLevel;
  overrideColorHex?: string;
}

/** AirportThresholdGroupModel */
export interface AirportThresholdGroupModel {  airportId?: string;
  usage?: AirportThresholdGroupUsage;
  thresholds?: AirportThresholdItemModel[];
  autoGenerated?: boolean;
  isOff?: boolean;
}

/** AirportThresholdItemModel */
export interface AirportThresholdItemModel {  type?: AirportThresholdType;
  enableState?: ThresholdEnableState;
  info?: AircraftThresholdLevelModel;
  watch?: AircraftThresholdLevelModel;
  warning?: AircraftThresholdLevelModel;
  critical?: AircraftThresholdLevelModel;
  emergency?: AircraftThresholdLevelModel;
  offInheritedLevels?: ThresholdLevel[];
}

/** AirportThresholdSettingsItemModel */
export interface AirportThresholdSettingsItemModel {  type?: AirportThresholdType;
  priority?: number;
  alerts?: AirportThresholdAlertOptions;
}

/** AirportThresholdsModel */
export interface AirportThresholdsModel {  thresholds?: AirportThresholdGroupModel[];
  options?: AirportThresholdSettingsItemModel[];
}

/** ArrivalGateRequest */
export interface ArrivalGateRequest {  aircraftId?: string;
  origin?: string;
  originalDepartureDateTime?: string;
  gateNo?: string;
}

/** AviationSentryLoginResponse */
export interface AviationSentryLoginResponse {  redirectUrl?: string;
}

/** BaseMapModelV2 */
export interface BaseMapModelV2 {  version?: number;
  buildDate?: string;
}

/** ChatTurn */
export interface ChatTurn {  role?: AiChatRole;
  content?: string;
}

/** Clarification */
export interface Clarification {  question?: string;
  suggestedAnswers?: string[];
}

/** CompanyMonitorSettingsSet */
export interface CompanyMonitorSettingsSet {  currentFEWebVersion?: string;
  currentDbFEWebVersion?: number;
  originalFEWebVersion?: string;
  originalDbFEWebVersion?: number;
  id?: string;
  lastUpdate?: string;
  monitorOptions?: MonitorOptionsModel;
  airportThresholds?: AirportThresholdsModel;
  aircraftThresholds?: AircraftThresholdItemModel[];
  Type?: MonitorSettingsType;
  companyMode?: CompanyThresholdsMode;
}

/** CreateFilterGroupRequest */
export interface CreateFilterGroupRequest {  name?: string;
  type?: FilterGroupType;
  members?: string[];
  isCompany?: boolean;
}

/** CreateNoteRequest */
export interface CreateNoteRequest {  type?: NoteType;
  itemId?: string;
  content?: string;
  origin?: string;
  depDateTime?: string;
  etaDate?: string;
  isCompany?: boolean;
}

/** DepartureGateRequest */
export interface DepartureGateRequest {  aircraftId?: string;
  origin?: string;
  originalDepartureDateTime?: string;
  gateNo?: string;
}

/** DiversionRecoveryPriorityRequest */
export interface DiversionRecoveryPriorityRequest {  aircraftId?: string;
  origin?: string;
  originalDepartureDateTime?: string;
  priority?: number;
}

/** DrawingObject */
export interface DrawingObject {  id?: string;
  name?: string;
  type?: DrawingObjectType;
  isCompany?: boolean;
  label?: DrawingObjectLabelSettings;
  line?: DrawingObjectLineSettings;
  fill?: DrawingObjectFillSettings;
  center?: DrawingObjectCenterSettings;
  zoom?: DrawingObjectZoomSettings;
  category?: DrawingObjectCategory;
  altitude?: DrawingObjectAltitudeRange;
  geometry?: DrawingObjectGeometry;
  alerts?: DrawingObjectAlerts;
  validTime?: DrawingObjectValidTimeSettings;
  fpmProperties?: DrawingObjectFPMProperties;
  deleted?: boolean;
}

/** DrawingObjectAlerts */
export interface DrawingObjectAlerts {  plane?: boolean;
  route?: boolean;
}

/** DrawingObjectAltitudeRange */
export interface DrawingObjectAltitudeRange {  min?: number;
  max?: number;
}

/** DrawingObjectCenterSettings */
export interface DrawingObjectCenterSettings {  style?: DrawingObjectCenterStyle;
  color?: string;
  size?: number;
}

/** DrawingObjectCreateOrUpdateRequestModel */
export interface DrawingObjectCreateOrUpdateRequestModel {  name?: string;
  type?: DrawingObjectType;
  isCompany?: boolean;
  label?: DrawingObjectLabelSettings;
  line?: DrawingObjectLineSettings;
  fill?: DrawingObjectFillSettings;
  center?: DrawingObjectCenterSettings;
  zoom?: DrawingObjectZoomSettings;
  category?: DrawingObjectCategory;
  altitude?: DrawingObjectAltitudeRange;
  geometry?: DrawingObjectGeometry;
  alerts?: DrawingObjectAlerts;
  validTime?: DrawingObjectValidTimeSettings;
  fpmProperties?: DrawingObjectFPMProperties;
}

/** DrawingObjectCreateResponseModel */
export interface DrawingObjectCreateResponseModel {  id?: string;
}

/** DrawingObjectFPMProperties */
export interface DrawingObjectFPMProperties {  sync?: boolean;
  FPMSyncType?: FPMSync;
}

/** DrawingObjectFillSettings */
export interface DrawingObjectFillSettings {  color?: string;
  style?: DrawingObjectFillStyle;
}

/** DrawingObjectGeometry */
export interface DrawingObjectGeometry {  centerUnits?: DrawingObjectCenterUnits;
  centerX?: number;
  centerY?: number;
  radiusUnits?: DrawingObjectOffsetUnits;
  radiusX?: number;
  radiusY?: number;
  sizeUnits?: DrawingObjectOffsetUnits;
  width?: number;
  height?: number;
  polygonCoordinates?: number[][];
}

/** DrawingObjectGetResponseModel */
export interface DrawingObjectGetResponseModel {  dateCreated?: string;
  createdBy?: string;
  editedBy?: string;
  dateEdited?: string;
  object?: DrawingObject;
}

/** DrawingObjectLabelSettings */
export interface DrawingObjectLabelSettings {  text?: string;
  alignment?: DrawingObjectLabelAlignment;
  color?: string;
}

/** DrawingObjectLineSettings */
export interface DrawingObjectLineSettings {  style?: DrawingObjectLineType;
  width?: number;
  color?: string;
}

/** DrawingObjectValidTimeSettings */
export interface DrawingObjectValidTimeSettings {  startDay?: string;
  endDay?: string;
  startTime?: string;
  endTime?: string;
  activeDaysOfWeek?: DayOfWeek;
  greyOutNonActive?: boolean;
}

/** DrawingObjectZoomSettings */
export interface DrawingObjectZoomSettings {  object?: number;
  point?: number;
  label?: number;
}

/** DrawingObjectsGetResponseModel */
export interface DrawingObjectsGetResponseModel {  drawings?: FEWebDrawingGet[];
  deleted?: string[];
}

/** EmergencyBeaconCodeModel */
export interface EmergencyBeaconCodeModel {  code?: number;
  text?: string;
}

/** FEMonitorSettingsModel */
export interface FEMonitorSettingsModel {  company?: CompanyMonitorSettingsSet;
  user?: UserMonitorSettingsSet;
}

/** FEServerFlightDataRouteWindAltitudePoint */
export interface FEServerFlightDataRouteWindAltitudePoint {  u?: number;
  v?: number;
  t?: number;
}

/** FEServerFlightDataRouteWindPoint */
export interface FEServerFlightDataRouteWindPoint {  dar?: number;
  oar?: number;
  alts?: FEServerFlightDataRouteWindAltitudePoint[];
}

/** FEServerFlightDataRouteWinds */
export interface FEServerFlightDataRouteWinds {  altitudes?: number[];
  elements?: FEServerFlightDataRouteWindPoint[];
  windIncrement?: number;
  routeId?: number;
}

/** FEWebDrawingGet */
export interface FEWebDrawingGet {  dateCreated?: string;
  createdBy?: string;
  editedBy?: string;
  dateEdited?: string;
  object?: DrawingObject;
}

/** FeedbackRequestModelV2 */
export interface FeedbackRequestModelV2 {  name?: string;
  phoneNumber?: string;
  email?: string;
  feedbackType?: FeedbackTypeEnum;
  feedback?: string;
  version?: string;
}

/** FilterGroupDto */
export interface FilterGroupDto {  id?: string;
  name?: string;
  type?: FilterGroupType;
  members?: string[];
  isCompany?: boolean;
  lastUpdate?: string;
}

/** GetAirportDiversionCapacityReport */
export interface GetAirportDiversionCapacityReport {  narrow?: number;
  wide?: number;
}

/** GetAirportDiversionCapacityResponse */
export interface GetAirportDiversionCapacityResponse {  status?: GetDiversionCapacityStatus;
  groupId?: string;
  faaId?: string;
  icaoId?: string;
  airline?: GetAirportDiversionCapacityReport;
  network?: GetAirportDiversionCapacityReport;
  all?: GetAirportDiversionCapacityReport;
  closureType?: ClosureType;
  closureStartDate?: string;
  closureEndDate?: string;
  phoneNumber?: string;
  comments?: string;
  lastUpdate?: string;
}

/** GetCustomEventsResponseModelItem */
export interface GetCustomEventsResponseModelItem {  code?: number;
  providerId?: number;
  displayName?: string;
  eventListText?: string;
  spokenText?: string;
}

/** GetFilterGroupsResponse */
export interface GetFilterGroupsResponse {  items?: FilterGroupDto[];
  deletedIds?: string[];
}

/** GetFlightRouteWindsRequest */
export interface GetFlightRouteWindsRequest {  acid?: string;
  origin?: string;
  departureTime?: string;
}

/** GetHistoricalDurationsResponse */
export interface GetHistoricalDurationsResponse {  aerodrome?: string;
  airline?: string;
  startTime?: string;
  endTime?: string;
  dataPoints?: HistoricalDurationDto[];
  airlineDataPoints?: HistoricalDurationDto[];
}

/** GetMapSettingsResponseModel */
export interface GetMapSettingsResponseModel {  navSources?: NavMapModelV2[];
  baseSources?: BaseMapModelV2[];
  tileUrl?: string;
}

/** GetNotesResponse */
export interface GetNotesResponse {  items?: NoteDto[];
  deletedIds?: string[];
}

/** GetUDViewResponseModelV2 */
export interface GetUDViewResponseModelV2 {  items?: UDViewModel[];
  deleted?: string[];
}

/** GetUserSettingsResponseModel */
export interface GetUserSettingsResponseModel {  items?: SettingsItem[];
}

/** HistoricalDurationDto */
export interface HistoricalDurationDto {  timestamp?: string;
  count?: number;
  outboundCount?: number;
  inboundCount?: number;
  avgOutboundTotal?: number;
  avgInboundTotal?: number;
  avgOutboundRamp?: number;
  avgOutboundHold?: number;
  avgOutboundTaxi?: number;
  avgOutboundQueue?: number;
  avgInboundTaxi?: number;
  avgInboundHold?: number;
  avgInboundRamp?: number;
}

/** LoginErrorResponseModel */
export interface LoginErrorResponseModel {  code?: LoginResultCode;
}

/** LoginRequestModelV2 */
export interface LoginRequestModelV2 {  userId?: string;
  password?: string;
}

/** LoginResponseModelV2 */
export interface LoginResponseModelV2 {  accessToken?: string;
  refreshToken?: string;
}

/** LoginSsoErrorResponseModel */
export interface LoginSsoErrorResponseModel {  code?: LoginIdentityProviderResultCode;
}

/** LoginSsoResponseModel */
export interface LoginSsoResponseModel {  wsPasscode?: string;
  accessToken?: string;
  refreshToken?: string;
  fpmId?: string;
}

/** LogoutRequestModel */
export interface LogoutRequestModel {  refreshToken?: string;
}

/** ManualThreePdiEntryRequest */
export interface ManualThreePdiEntryRequest {  aircraftId?: string;
  origin?: string;
  originalDepartureDateTime?: string;
  phase?: FlightPhase;
  phaseDateTime?: string;
}

/** MonitorImpactsDistanceSettings */
export interface MonitorImpactsDistanceSettings {  volcanicAsh?: number;
  sigmet?: number;
  convSigment?: number;
  dsua?: number;
  edrTurbulence?: number;
  turbulence?: number;
  icing?: number;
  contrail?: number;
  tcf?: number;
}

/** MonitorOptionsModel */
export interface MonitorOptionsModel {  monitorOriginDepartureMinMinutes?: number;
  monitorOriginWithoutDepartureTime?: boolean;
  monitorDestinationDepartureMinMinutes?: number;
  monitorDestinationWithoutArrivalTime?: boolean;
  monitorAltDepartureMinMinutes?: number;
  monitorAltWithoutArrivalTime?: boolean;
  emergencyBeacons?: EmergencyBeaconCodeModel[];
  ignoredCompanyBeaconCodes?: number[];
  altitudeChangeWindowMinutes?: number;
  suppressAltitudeMonitorMiles?: number;
  monitorImpactDistance?: MonitorImpactsDistanceSettings;
  tafWindowHours?: number;
  airportMonitorStatusInclude?: AirportMonitorStatusInclude;
}

/** NavMapModelV2 */
export interface NavMapModelV2 {  company?: string;
  sequence?: number;
  version?: number;
  cycleDate?: string;
  buildDate?: string;
}

/** NotamSearchResultItem */
export interface NotamSearchResultItem {  rawText?: string;
  id?: number;
}

/** NoteDto */
export interface NoteDto {  id?: string;
  type?: NoteType;
  itemId?: string;
  content?: string;
  origin?: string;
  depDateTime?: string;
  etaDate?: string;
  dateCreated?: string;
  createdBy?: string;
  editedBy?: string;
  dateEdited?: string;
  isCompany?: boolean;
}

/** NoteItemsSummaryDto */
export interface NoteItemsSummaryDto {  aircraft?: string[];
  airports?: string[];
  tails?: string[];
}

/** ProblemDetails */
export interface ProblemDetails {  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
}

/** RefreshTokenErrorResponseModel */
export interface RefreshTokenErrorResponseModel {  code?: RefreshTokenResultCode;
}

/** RefreshTokenRequestModel */
export interface RefreshTokenRequestModel {  refreshToken?: string;
}

/** RefreshTokenResponseModel */
export interface RefreshTokenResponseModel {  accessToken?: string;
  refreshToken?: string;
}

/** RunwayEnd */
export interface RunwayEnd {  id?: string;
  heading?: number;
  usage?: RunwayUsage;
}

/** RunwayPair */
export interface RunwayPair {  base?: RunwayEnd;
  recip?: RunwayEnd;
  length?: number;
}

/** SettingsItem */
export interface SettingsItem {  key?: string;
  value?: string;
}

/** SystemHubDetails */
export interface SystemHubDetails {  noticeAlerts?: SystemHubNoticeAlert[];
  scheduledMaintenances?: SystemHubScheduledMaintenance[];
  newsAnnouncements?: SystemHubNewsAnnouncement[];
  trainingFeatures?: SystemHubTrainingFeature[];
  feeds?: SystemHubFeedStatus[];
}

/** SystemHubFeedStatus */
export interface SystemHubFeedStatus {  id?: number;
  type?: string;
  name?: string;
  mode?: string;
  state?: string;
  color?: number;
}

/** SystemHubNewsAnnouncement */
export interface SystemHubNewsAnnouncement {  id?: number;
  time?: string;
  title?: string;
  description?: string;
  link?: string;
  importanceLevel?: SystemHubImportanceLevel;
  lastUpdate?: string;
}

/** SystemHubNoticeAlert */
export interface SystemHubNoticeAlert {  id?: number;
  time?: string;
  type?: SystemHubNoticeType;
  title?: string;
  description?: string;
  importanceLevel?: SystemHubImportanceLevel;
  lastUpdate?: string;
}

/** SystemHubScheduledMaintenance */
export interface SystemHubScheduledMaintenance {  id?: number;
  startTime?: string;
  endTime?: string;
  importanceLevel?: SystemHubImportanceLevel;
  title?: string;
  description?: string;
  lastUpdate?: string;
}

/** SystemHubStatusModel */
export interface SystemHubStatusModel {  importanceLevel?: SystemHubImportanceLevel;
  showPopup?: boolean;
  popupText?: string;
  lastUpdate?: string;
}

/** SystemHubTrainingFeature */
export interface SystemHubTrainingFeature {  id?: number;
  time?: string;
  title?: string;
  description?: string;
  link?: string;
  importanceLevel?: SystemHubImportanceLevel;
  lastUpdate?: string;
}

/** UDViewAirportModel */
export interface UDViewAirportModel {  show?: boolean;
  myAirports?: boolean;
  myAirportsColor?: string;
  tower?: boolean;
  towerColor?: string;
  noTower?: boolean;
  noTowerColor?: string;
  heliport?: boolean;
  heliportColor?: string;
  seaplane?: boolean;
  seaplaneColor?: string;
  others?: boolean;
  othersColor?: string;
  runways?: boolean;
  deicing?: boolean;
  filterGroup?: UDViewFilterGroupModel;
  settings?: UDViewCommonSettingsItem[];
}

/** UDViewAirspaceModel */
export interface UDViewAirspaceModel {  show?: boolean;
  fir?: boolean;
  uir?: boolean;
  classA?: boolean;
  classB?: boolean;
  classC?: boolean;
  classD?: boolean;
  classE?: boolean;
  classF?: boolean;
  classG?: boolean;
  other?: boolean;
  filterGroup?: UDViewFilterGroupModel;
}

/** UDViewAirwayModel */
export interface UDViewAirwayModel {  show?: boolean;
  high?: boolean;
  highColor?: string;
  low?: boolean;
  lowColor?: string;
  settings?: UDViewAirwaysSettingsModel;
  filterGroup?: UDViewFilterGroupModel;
}

/** UDViewAirwaysSettingsModel */
export interface UDViewAirwaysSettingsModel {  fontSize?: number;
}

/** UDViewCommonSettingsItem */
export interface UDViewCommonSettingsItem {  key?: string;
  value?: string;
}

/** UDViewDrawingObjectModel */
export interface UDViewDrawingObjectModel {  show?: boolean;
  avoidance?: boolean;
  alert?: boolean;
  view?: boolean;
  viewObjectIds?: string[];
}

/** UDViewFilterGroupConfigModel */
export interface UDViewFilterGroupConfigModel {  color?: string;
}

/** UDViewFilterGroupModel */
export interface UDViewFilterGroupModel {  show?: boolean;
  filterGroupIds?: string[];
  config?: object;
}

/** UDViewFixesModel */
export interface UDViewFixesModel {  show?: boolean;
  latLon?: boolean;
  latLonColor?: string;
  nrs?: boolean;
  nrsColor?: string;
  aacaA_SUA?: boolean;
  aacaaSuaColor?: string;
  intersection?: boolean;
  intersectionColor?: string;
  rnav?: boolean;
  rnavColor?: string;
  terminal?: boolean;
  terminalColor?: string;
  vfr?: boolean;
  vfrColor?: string;
  other?: boolean;
  otherColor?: string;
  low?: boolean;
  high?: boolean;
  filterGroup?: UDViewFilterGroupModel;
  settings?: UDViewFixesSettingsModel;
}

/** UDViewFixesSettingsModel */
export interface UDViewFixesSettingsModel {  fontSize?: number;
}

/** UDViewFlightServiceStationModel */
export interface UDViewFlightServiceStationModel {  show?: boolean;
  filterGroup?: UDViewFilterGroupModel;
}

/** UDViewGeographyMapModel */
export interface UDViewGeographyMapModel {  drawDayNight?: boolean;
}

/** UDViewGeojsonModel */
export interface UDViewGeojsonModel {  show?: boolean;
  paths?: UDViewGeojsonPathModel[];
}

/** UDViewGeojsonPathModel */
export interface UDViewGeojsonPathModel {  type?: UDViewGeojsonPathType;
  name?: string;
  show?: boolean;
  url?: string;
  fileHandle?: string;
}

/** UDViewGridMoraModel */
export interface UDViewGridMoraModel {  show?: boolean;
}

/** UDViewHoldingModel */
export interface UDViewHoldingModel {  show?: boolean;
  lowAltitude?: boolean;
  highAltitude?: boolean;
  sid?: boolean;
  star?: boolean;
  approach?: boolean;
  missedApproach?: boolean;
  other?: boolean;
  filterGroup?: UDViewFilterGroupModel;
}

/** UDViewLatLonModel */
export interface UDViewLatLonModel {  show?: boolean;
}

/** UDViewMapModel */
export interface UDViewMapModel {  dayNightShading?: boolean;
  dayNightShadingType?: UDViewDayNightShadingType;
  selectedTwilightTypes?: UDViewDayNightTwilightType;
  lat?: number;
  lon?: number;
  pitch?: number;
  bearing?: number;
  zoom?: number;
  terrain?: boolean;
  style?: UDViewMapStyle;
  defaultSky?: UDViewMapSkyModel;
  useGlobeView?: boolean;
  globeAutoRotate?: boolean;
  globeAutoRotateSpeed?: number;
  globeViewSky?: UDViewMapSkyModel;
  terrainShading?: UDViewTerrainShadingModel;
}

/** UDViewMapSkyModel */
export interface UDViewMapSkyModel {  skyColor?: string;
  skyHorizonBlend?: number;
  horizonColor?: string;
  horizonFogBlend?: number;
  fogColor?: string;
  fogGroundBlend?: number;
  atmosphereBlend?: number;
}

/** UDViewMiscellaneousModel */
export interface UDViewMiscellaneousModel {  backGroundBrightness?: number;
}

/** UDViewModel */
export interface UDViewModel {  currentFEWebVersion?: string;
  currentDbFEWebVersion?: number;
  originalFEWebVersion?: string;
  originalDbFEWebVersion?: number;
  name?: string;
  id?: string;
  lastUpdate?: string;
  deleted?: boolean;
  type?: UDViewType;
  includeInSlideshow?: boolean;
  isFavorite?: boolean;
  plane?: UDViewPlaneModel;
  weather?: UDViewWeatherModel;
  staticData?: UDViewStaticDataModel;
  map?: UDViewMapModel;
}

/** UDViewNavaidsModel */
export interface UDViewNavaidsModel {  show?: boolean;
  ndb?: boolean;
  ndbColor?: string;
  vor?: boolean;
  vorColor?: string;
  voR_DME?: boolean;
  vorDmeColor?: string;
  vortac?: boolean;
  vortacColor?: string;
  tacan?: boolean;
  tacanColor?: string;
  dme?: boolean;
  dmeColor?: string;
  ndB_DME?: boolean;
  ndbDmeColor?: string;
  rings?: UDViewNavaidsRingsModel;
  settings?: UDViewFixesSettingsModel;
  filterGroup?: UDViewFilterGroupModel;
}

/** UDViewNavaidsRingsModel */
export interface UDViewNavaidsRingsModel {  draw?: boolean;
  drawTerminal?: boolean;
  drawLow?: boolean;
  drawHigh?: boolean;
  drawUnrestricted?: boolean;
  fillColor?: string;
  lineColor?: string;
}

/** UDViewOverwaterAreasModel */
export interface UDViewOverwaterAreasModel {  show?: boolean;
  lineColor?: string;
}

/** UDViewPlaneCityPairSettingsModel */
export interface UDViewPlaneCityPairSettingsModel {  show?: boolean;
  active?: boolean;
  planned?: boolean;
  scheduled?: boolean;
  activeColor?: string;
  plannedColor?: string;
  scheduledColor?: string;
}

/** UDViewPlaneFilterListModel */
export interface UDViewPlaneFilterListModel {  useFilters?: boolean;
  startWithNoPlanes?: boolean;
  planeFilterAutoZoom?: UDViewPlaneFilterAutoZoomEnum;
  planeFilterSettings?: UDViewPlaneFilterSettingModel[];
}

/** UDViewPlaneFilterSettingModel */
export interface UDViewPlaneFilterSettingModel {  name?: string;
  color?: string;
  isActive?: boolean;
  include?: boolean;
  airlineType?: UDViewPlaneFilterAirlineTypeEnum;
  useMyFleet?: boolean;
  acid?: string;
  origin?: string;
  destination?: string;
  destinationType?: UDViewDestinationTypeEnum;
  useAltAirport?: boolean;
  beaconCode?: string;
  icaoCode?: string;
  altitudeLower?: number;
  altitudeUpper?: number;
  speedLower?: number;
  speedUpper?: number;
  aircraftType?: string;
  filterObjectType?: UDViewFlightFilterObjectEnum;
  timeBefore?: number;
  timeAfter?: number;
  timeType?: UDViewTimeFilterTypeEnum;
  distanceToDestination?: number;
  sectorDeskId?: string;
  tail?: string;
  diverted?: boolean;
  holding?: boolean;
  showTags?: boolean;
  showHistory?: boolean;
  tagTextColor?: UDViewTagFilterColor;
}

/** UDViewPlaneIconSettingModel */
export interface UDViewPlaneIconSettingModel {  zoomLevel?: number;
  size?: UDViewPlaneIconSizeEnum;
  type?: UDViewPlaneIconTypeEnum;
  drawShadow?: boolean;
}

/** UDViewPlaneModel */
export interface UDViewPlaneModel {  settings?: UDViewPlaneSettingModel;
  filter?: UDViewPlaneFilterListModel;
  icon?: UDViewPlaneIconSettingModel;
  tag?: UDViewPlaneTagModel;
  range?: UDViewPlaneRangeModel;
  vector?: UDViewPlaneVectorModel;
}

/** UDViewPlaneRangeModel */
export interface UDViewPlaneRangeModel {  isVisible?: boolean;
  factor?: number;
  type?: UDViewRangeType;
  color?: string;
  lineColor?: string;
}

/** UDViewPlaneRouteFlownPointSettingModel */
export interface UDViewPlaneRouteFlownPointSettingModel {  enabled?: boolean;
  color?: string;
}

/** UDViewPlaneRouteFlownSettingModel */
export interface UDViewPlaneRouteFlownSettingModel {  defaultColor?: string;
  projected?: UDViewPlaneRouteFlownPointSettingModel;
  acars?: UDViewPlaneRouteFlownPointSettingModel;
  adsbTerrestrial?: UDViewPlaneRouteFlownPointSettingModel;
  adsbSatellite?: UDViewPlaneRouteFlownPointSettingModel;
  faaAnsp?: UDViewPlaneRouteFlownPointSettingModel;
}

/** UDViewPlaneSettingModel */
export interface UDViewPlaneSettingModel {  show?: boolean;
  showHistory?: boolean;
  showActive?: boolean;
  showParked?: boolean;
  showScheduled?: boolean;
  showPlanned?: boolean;
  showDiversionLines?: boolean;
  showGroundVehicles?: boolean;
  historyColor?: string;
  parkedColor?: string;
  scheduledColor?: string;
  plannedColor?: string;
  flightPlanColor?: string;
  oldFlightPlanColor?: string;
  routeLabelsColor?: string;
  routeFlownColor?: string;
  flown3PdiColor?: string;
  flownProjectionColor?: string;
  showFlightPlanPointMark?: boolean;
  showFlightPlanPointLabel?: boolean;
  flightPlanExtent?: boolean;
  showRouteFlownPointMark?: boolean;
  showFlightPlanTime?: UDViewShowFlightPlanTimeEnum;
  showProjectedPoints?: boolean;
  showLastReal?: boolean;
  routeFlown?: UDViewPlaneRouteFlownSettingModel;
  showProjectedHighlight?: boolean;
  projectedHighlightColor?: string;
  enableCoastMode?: boolean;
  showCoastPosition?: boolean;
  historyModern?: boolean;
  historyColorSource?: UDViewHistoryColorSourceEnum;
  coastPositionColor?: string;
  enableTimeDistance?: boolean;
  udViewTimeDistanceMode?: UDViewTimeDistanceMode;
  cityPair?: UDViewPlaneCityPairSettingsModel;
}

/** UDViewPlaneTagLabelModel */
export interface UDViewPlaneTagLabelModel {  type?: UDViewTagSelectionEnum;
  label?: string;
  row?: number;
  col?: number;
  enabled?: boolean;
}

/** UDViewPlaneTagModel */
export interface UDViewPlaneTagModel {  show?: boolean;
  labels?: UDViewPlaneTagLabelModel[];
  zoomLevel?: number;
  disableTagLeader?: boolean;
  enableAutoTag?: boolean;
  tagShowMyNotesIcon?: boolean;
  hideAirlineId?: boolean;
  showLabelBackground?: boolean;
  backgroundColor?: string;
  tagOutlineMode?: UDViewTagOutlineMode;
  tagOutlineColor?: string;
  textColor?: string;
}

/** UDViewPlaneVectorModel */
export interface UDViewPlaneVectorModel {  isVisible?: boolean;
  factor?: number;
  type?: UDViewRangeType;
  lineColor?: string;
}

/** UDViewSUAModel */
export interface UDViewSUAModel {  show?: boolean;
  static?: boolean;
  dynamic?: boolean;
  alert?: boolean;
  caution?: boolean;
  danger?: boolean;
  militaryArea?: boolean;
  prohibited?: boolean;
  restricted?: boolean;
  traning?: boolean;
  warning?: boolean;
  unkown?: boolean;
  filterGroup?: UDViewFilterGroupModel;
}

/** UDViewSidsModel */
export interface UDViewSidsModel {  show?: boolean;
  filterGroup?: UDViewFilterGroupModel;
}

/** UDViewStarsModel */
export interface UDViewStarsModel {  show?: boolean;
  filterGroup?: UDViewFilterGroupModel;
}

/** UDViewStaticDataModel */
export interface UDViewStaticDataModel {  airport?: UDViewAirportModel;
  airspace?: UDViewAirspaceModel;
  airway?: UDViewAirwayModel;
  drawingObjects?: UDViewDrawingObjectModel;
  fixes?: UDViewFixesModel;
  flightServiceStation?: UDViewFlightServiceStationModel;
  geographyMap?: UDViewGeographyMapModel;
  holding?: UDViewHoldingModel;
  gridMora?: UDViewGridMoraModel;
  latLon?: UDViewLatLonModel;
  navaids?: UDViewNavaidsModel;
  overwaterAreas?: UDViewOverwaterAreasModel;
  miscellaneous?: UDViewMiscellaneousModel;
  sids?: UDViewSidsModel;
  stars?: UDViewStarsModel;
  sua?: UDViewSUAModel;
  timeZone?: UDViewTimeZoneModel;
  weatherStation?: UDViewWeatherStationModel;
  customGeojson?: UDViewGeojsonModel;
}

/** UDViewTerrainShadingModel */
export interface UDViewTerrainShadingModel {  enabled?: boolean;
  type?: UDViewTerrainShadingType;
  opacity?: number;
  altitude?: number;
  color?: string;
}

/** UDViewTimeZoneModel */
export interface UDViewTimeZoneModel {  show?: boolean;
}

/** UDViewWeatherModel */
export interface UDViewWeatherModel {  show?: boolean;
  WeatherList?: number[];
  hidden?: number[];
  tempWindDepiction?: UDViewWindDepiction;
  tempHeatmapStyle?: UDViewHeatMapStyle;
  tempParticleColor?: UDViewWindParticleColor;
  tempHeatmapOpacity?: number;
  tempAltitude?: number;
  settings?: UDViewWeatherSettingsItem[];
}

/** UDViewWeatherSettingsItem */
export interface UDViewWeatherSettingsItem {  key?: string;
  value?: string;
}

/** UDViewWeatherStationModel */
export interface UDViewWeatherStationModel {  show?: boolean;
  filterGroup?: UDViewFilterGroupModel;
}

/** UdViewCreateOrUpdateRequestModel */
export interface UdViewCreateOrUpdateRequestModel {  currentFEWebVersion?: string;
  currentDbFEWebVersion?: number;
  originalFEWebVersion?: string;
  originalDbFEWebVersion?: number;
  name?: string;
  type?: UDViewType;
  includeInSlideshow?: boolean;
  isFavorite?: boolean;
  plane?: UDViewPlaneModel;
  weather?: UDViewWeatherModel;
  staticData?: UDViewStaticDataModel;
  map?: UDViewMapModel;
}

/** UdViewCreateResponseModel */
export interface UdViewCreateResponseModel {  id?: string;
}

/** UpdateFilterGroupRequest */
export interface UpdateFilterGroupRequest {  name?: string;
  type?: FilterGroupType;
  members?: string[];
  isCompany?: boolean;
}

/** UpdateNoteRequest */
export interface UpdateNoteRequest {  content?: string;
}

/** UpdateUserSettingRequestModel */
export interface UpdateUserSettingRequestModel {  type?: UpdateUserSettingUpdateType;
  key?: string;
  item?: SettingsItem;
}

/** UserMonitorSettingsSet */
export interface UserMonitorSettingsSet {  currentFEWebVersion?: string;
  currentDbFEWebVersion?: number;
  originalFEWebVersion?: string;
  originalDbFEWebVersion?: number;
  id?: string;
  lastUpdate?: string;
  monitorOptions?: MonitorOptionsModel;
  airportThresholds?: AirportThresholdsModel;
  aircraftThresholds?: AircraftThresholdItemModel[];
  Type?: MonitorSettingsType;
}

export type AiChatRole = 0 | 1;

export type AiResponseKind = 0 | 1 | 2;

export type AircraftThresholdType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 32
  | 33
  | 34
  | 35
  | 36
  | 37
  | 38
  | 39
  | 40
  | 41
  | 42
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48
  | 49
  | 50
  | 51
  | 52
  | 53
  | 54
  | 55
  | 56
  | 57
  | 58
  | 59
  | 60
  | 61
  | 62
  | 63
  | 64
  | 65
  | 66;

export type AirportThresholdGroupUsage = 0 | 1 | 2 | 3;

export type AirportThresholdType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24;

export type ClosureType = 0 | 1 | 2;

export type CompanyThresholdsMode = 0 | 1 | 2 | 3;

export type DayOfWeek = 1 | 2 | 4 | 8 | 16 | 32 | 64;

export type DrawingObjectCategory = 0 | 1 | 2;

export type DrawingObjectCenterStyle = 0 | 1 | 2 | 3 | 4 | 5;

export type DrawingObjectCenterUnits = 0 | 1;

export type DrawingObjectFillStyle = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type DrawingObjectLabelAlignment = 0 | 1 | 2 | 3;

export type DrawingObjectLineType = 0 | 1 | 2 | 3;

export type DrawingObjectOffsetUnits = 0 | 1;

export type DrawingObjectType = 0 | 1 | 2;

export type FPMSync = 0 | 1;

export type FeedbackTypeEnum = 0 | 1 | 2 | 3 | 4;

export type FilterGroupType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export type FlightPhase = 0 | 1 | 2 | 3;

export type GetDiversionCapacityStatus = 0 | 1;

export type LoginIdentityProviderResultCode = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export type LoginResultCode = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type MonitorSettingsType = 0 | 1;

export type NoteType = 0 | 1 | 2 | 3;
export type ProblemDetailsWithAdditionalProperties = ProblemDetails & { [additionalProperties: string]: any | null };
export type RefreshTokenResultCode = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export type RunwayUsage = 0 | 1 | 2;

export type SystemHubImportanceLevel = 0 | 1 | 2 | 3;

export type SystemHubNoticeType = 0 | 1;

export type ThresholdAlertMinimumLevel = 0 | 1 | 2 | 3 | 4;

export type ThresholdEnableState = 0 | 1 | 2;

export type ThresholdLevel = 0 | 1 | 2 | 3 | 4;

export type ThresholdLevelActionType = 0 | 1 | 2 | 3;

export type UDViewDayNightShadingType = 0 | 1 | 2;

export type UDViewDayNightTwilightType = 0 | 1 | 2 | 4 | 8;

export type UDViewDestinationTypeEnum = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type UDViewFlightFilterObjectEnum = 0 | 1 | 2 | 3;

export type UDViewGeojsonPathType = 0 | 1;

export type UDViewHeatMapStyle = 0 | 1 | 2 | 3 | 4;

export type UDViewHistoryColorSourceEnum = 0 | 1;

export type UDViewMapStyle = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export type UDViewPlaneFilterAirlineTypeEnum = 1 | 2 | 3;

export type UDViewPlaneFilterAutoZoomEnum = 0 | 1 | 2;

export type UDViewPlaneIconSizeEnum = 0 | 1 | 2 | 3 | 4 | 5;

export type UDViewPlaneIconTypeEnum = 0 | 1 | 2;

export type UDViewRangeType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type UDViewShowFlightPlanTimeEnum = 0 | 1 | 2;

export type UDViewTagFilterColor = 0 | 1;

export type UDViewTagOutlineMode = 0 | 1 | 2;

export type UDViewTagSelectionEnum =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 32
  | 33
  | 34
  | 35
  | 36
  | 37
  | 38
  | 39
  | 40
  | 41
  | 42
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48
  | 49
  | 50
  | 51
  | 52
  | 53
  | 54
  | 55
  | 56
  | 57
  | 58
  | 59
  | 60
  | 61
  | 62
  | 63
  | 64
  | 65
  | 67
  | 68
  | 69
  | 70
  | 71
  | 72
  | 73
  | 74
  | 75
  | 76
  | 77
  | 78
  | 79
  | 80
  | 81
  | 82
  | 83
  | 84
  | 85
  | 86
  | 87
  | 88
  | 89
  | 90
  | 91;

export type UDViewTerrainShadingType = 0 | 1;

export type UDViewTimeDistanceMode = 0 | 1;

export type UDViewTimeFilterTypeEnum = 0 | 1 | 2;

export type UDViewType = 0 | 1;

export type UDViewWindDepiction = 0 | 1 | 2;

export type UDViewWindParticleColor = 0 | 1 | 2;

export type UpdateUserSettingUpdateType = 0 | 1;
